export const staticMetaProps = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/forum-rieltorov/`,
  seoTitle: 'Советы риэлторов и других специалистов недвижимости России - ЦИАН',
  seoDescription: `ЦИАН - форум о недвижимости, советы риэлторов и других специалистов недвижимости. Задать вопрос риэлтору.`,
  seoKeywords: 'недвижимость, форум, советы, вопрос-ответ',
});

const staticMetaPropsMarketTrend = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/forum-rieltorov-tendentsiy-rynka/`,
  seoTitle: 'Тенденции рынка недвижимости - советы и вопросы - ЦИАН',
  seoDescription: 'Тенденции рынка недвижимости -  советы и вопросы, полезная информация о недвижимости.' +
    ' Вся информация о тенденциях рынка - ЦИАН.',
  seoKeywords: 'Тенденции рынка, статьи, циан',
});

const staticMetaPropsSpecialist = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/forum-rieltorov-specialist/`,
  seoTitle: 'Специалист-специалисту - советы и вопросы - ЦИАН',
  seoDescription: 'Специалист-специалисту -  советы и вопросы, полезная информация о недвижимости.' +
    ' Вся информация о для специалиста - ЦИАН.',
  seoKeywords: 'Специалист-специалисту, статьи, циан',
});

const staticMetaPropsCityRealty = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/forum-rieltorov-gorodskaya-nedvizhimost/`,
  seoTitle: 'Городская недвижимость - советы и вопросы - ЦИАН',
  seoDescription: 'Городская недвижимость - советы и вопросы, полезная информация о недвижимости.' +
    ' Вся информация о городской недвижимости - ЦИАН.',
  seoKeywords: 'Городская недвижимость, статьи, циан',
});

const staticMetaPropsCityCommerceRealty = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/forum-rieltorov-kommercheskaya-nedvizhimost/`,
  seoTitle: 'Коммерческая недвижимость - советы и вопросы - ЦИАН',
  seoDescription: 'Коммерческая недвижимость - советы и вопросы, полезная информация о недвижимости.' +
    ' Вся информация о коммерческой недвижимости - ЦИАН.',
  seoKeywords: 'Коммерческая недвижимость, статьи, циан',
});

const staticMetaPropsCityCountryRealty = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/forum-rieltorov-zagorodnaya-nedvizhimost/`,
  seoTitle: 'Загородная недвижимость - советы и вопросы - ЦИАН',
  seoDescription: 'Загородная недвижимость - советы и вопросы, полезная информация о недвижимости.' +
    ' Вся информация о загородной недвижимости - ЦИАН.',
  seoKeywords: 'Загородная недвижимость, статьи, циан',
});

const staticMetaPropsCityForeignRealty = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/forum-rieltorov-zarubezhnaya-nedvizhimost/`,
  seoTitle: 'Зарубежная недвижимость - советы и вопросы - ЦИАН',
  seoDescription: 'Зарубежная недвижимость - советы и вопросы, полезная информация о недвижимости.' +
    ' Вся информация о зарубежной недвижимости - ЦИАН.',
  seoKeywords: 'Зарубежная недвижимость, статьи, циан',
});

const staticMetaPropsCityHypothec = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/forum-rieltorov-ipoteka/`,
  seoTitle: 'Ипотека - советы и вопросы - ЦИАН',
  seoDescription: `Ипотека - советы и вопросы, полезная информация о недвижимости. Вся информация о ипотеке - ЦИАН.`,
  seoKeywords: 'Ипотека, статьи, циан',
});

export const staticMetaPropsArray = [{
    type: '',
    data: staticMetaProps,
  }, {
    type: 'market_trend',
    data: staticMetaPropsMarketTrend,
  }, {
    type: 'specialist',
    data: staticMetaPropsSpecialist,
  }, {
    type: 'city_realty',
    data: staticMetaPropsCityRealty,
  }, {
    type: 'commerce_realty',
    data: staticMetaPropsCityCommerceRealty,
  }, {
    type: 'country_realty',
    data: staticMetaPropsCityCountryRealty,
  }, {
    type: 'foreign_realty',
    data: staticMetaPropsCityForeignRealty,
  }, {
    type: 'hypothec',
    data: staticMetaPropsCityHypothec,
  }];
